import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { NButton, SelectOption, NDatePicker } from 'naive-ui';
import moment, { Moment } from 'moment';

import ComponentBase from '~/components/component-base';
import PageHeader from '~/core/components/page-header/page-header.vue';
import ExportDataModal from '~/components/modals/export-data-modal/export-data-modal.vue';

import { useDashboardStore } from '~/store/dashboard.store';
import { useStationStore } from '~/store/station.store';

import { StationGroup } from '~/api/models/station-group.model';

export default defineComponent({

    extends: ComponentBase,

    components: {

        PageHeader,

        ExportDataModal,

        NDatePicker,
        NButton,
    },

    data() {


        const data = {
            isLoading: false,
            avoltaConnectLogo: require('@/avolta-connect-logo.png').default,
            timerange:  [0,0],
            shortcuts: {},
            interval: null,
            now: moment(),
        }
        const now = moment().unix() * 1000;
        data.shortcuts[this.$t('advanced_view.last_month')] = [moment().subtract(1, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_6_month')] = [moment().subtract(6, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_quarter')] = [moment().subtract(3, 'month').unix() * 1000, now];
        data.shortcuts[this.$t('advanced_view.last_year')] = [moment().subtract(12, 'month').unix() * 1000, now];

        return data;
    },

    computed: {
        ...mapStores(useStationStore, useDashboardStore),
        ...mapState(useStationStore, ['groups', 'stations', 'group']),
        ...mapState(useDashboardStore, ['since', 'before']),

        options(): SelectOption[] {
            if (!this.groups) {
                return [];
            }

            return this.groups.map((grp: StationGroup) => {
                return {
                    label: grp.label || grp.name,
                    value: grp.id,
                    // children: grp.stations.map((station: Station) => ({label: this.getStationName(station), value: station.id}))
                } as SelectOption
            });
        },
    },

    mounted() {
        this.buildTimerange();
        this.interval = setInterval(() => this.now = moment(), 5 * 1000);
    },

    unmounted(): void {
        clearInterval(this.interval);
    },

    methods: {

        setMonthRange(range): void {
            const [start, end]: [number, number] = range;

            const since: Moment = moment.unix(start / 1000);
            const before: Moment = moment.unix(end / 1000).add(1, 'day');

            this.$router.replace({
                query: {
                    since: since.format(),
                    before: before.format(),
                }
            });
        },

        isRangeDateDisabled(ts: number, type: 'start' | 'end', range: [number, number]): boolean {
            if(moment.unix((ts / 1000)).isAfter(moment())) {
                return true;
            }

            if(!range) {
                return false;
            }

            return moment.unix(range[0] / 1000).diff(moment.unix(range[1] / 1000), 'months') > 12;
        },

        async refresh() {
            try {
                this.isLoading = true;
                // await this.stationStore.refresh();
                await this.dashboardStore.refresh();
            } catch (e) {
                this.$notifyError('Coud not refresh page', e);
            } finally {
                this.isLoading = false;
            }
        },

        buildTimerange(): [number, number] {

            if(!this.since || !this.before) {
                return [0,0];
            }

            this.timerange = [
                this.since.unix() * 1000,
                this.before.unix() * 1000,
            ];
        },

        exportData() {
            //@ts-ignore
            this.$refs.export.open();
        }
    },

    watch: {
        since() {
            this.buildTimerange();
        },

        before() {
            this.buildTimerange();
        },

        group(): void {
            this.now = moment();
        }
    }
});